<template>
  <div v-if="dialogVisible"
       id="com-task"
       :class="[isSmall?'confirmation-batch-upload-dialog-small':'confirmation-batch-upload-dialog']"
       ref="refMaterialBatchUploadDialog">
    <div class="batch-upload-dialog-main"
         v-show="!isSmall"
         v-loading="showLoading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         :style="[{width:titleWidth}]">
      <div class="batch-upload-dialog-title">
        <span>{{ title }}</span>
        <i class="el-dialog__close el-icon el-icon-close"
           style="width: 18px; height: 18px; cursor: pointer;"
           @click.stop="hideDialog"></i>
      </div>
      <div class="batch-upload-dialog-content">
        <!-- 上传前-->
        <confirmationUploadView
          ref="confirmationUploadViewRef"
          v-show="[0, 1].includes(confirmationExport.status)"
          :queryParams.sync="queryParams"
          :effect="effect"
          @uploadProgress="uploadProgress"
          @uploadFail="uploadFail"
        ></confirmationUploadView>
        <!-- 上传中-->
        <!-- 匹配中-->
        <confirmationUploading
          v-if="confirmationExport.status === 2"
          :matchProgress.sync="matchProgress"
          style="height: 356px;"
          @uploadProgress="uploadProgress"
          @clickSmall="clickSmall"
          @clickCancel="clickCancel"
        ></confirmationUploading>
        <!-- 上传结果-->
        <confirmationUploadResult v-if="confirmationExport.status === 3"
                              ref="refUploadResult"
                                  @close="close"
                              @clickRetry="clickRetry"
        ></confirmationUploadResult>
      </div>
    </div>
    <div v-show="isSmall" class="batch-upload-dialog-small-main">
      <div class="step-third-circle-small" @click="clickEnlarge">
        <img class="img-circle-small" src="@/assets/image/batch-upload-dialog/ic_circle.png">
        <img class="img-circle-center-small" src="@/assets/image/batch-upload-dialog/ic_circle_center.png">
        <span class="span-progress-small">{{ `${matchProgress ? matchProgress.toFixed(2) : 0}%` }}</span>
      </div>
    </div>

  </div>
</template>
<!--材料批量上传弹窗-->
<script>
import confirmationUploadView from '@/pages/case-import/confirmation-upload/confirmation-upload-view.vue';
import confirmationUploading from '@/pages/case-import/confirmation-upload/confirmation-uploading.vue';
import confirmationUploadResult from '@/pages/case-import/confirmation-upload/confirmation-upload-result.vue';
import {mapState} from 'vuex';

/**
 * 前端excel导出
 */

export default {
  name: 'confirmation-batch-upload-dialog',
  components: {
    confirmationUploadView,
    confirmationUploading,
    confirmationUploadResult,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },

    queryParams: {// 入口查询参数-业务
      type: Object,
      default: () => {
        return {};
      }
    },
    handlerFunc: {// 外部响应方法
      type: Function
    },
    effect: {
      type: String,
      default: 'light'
    }
  },
  data() {
    return {
      titleWidth: '635px',
      isSmall: false,
      showLoading: false,
      matchProgress: 50,
    };
  },
  computed: {
    ...mapState({confirmationExport: state => state.longTask.confirmationExport}),
    title() {
      if (this.confirmationExport.status === 3) {
        return '导入结果汇总';
      } else {
        return '补填信息导入';
      }
    }
  },
  watch: {
    dialogVisible() {
      this.init();
    },
  },
  methods: {
    // 中断上传 bug - 10714
    abortUpload(succ_cb) {
      if (this.matchStep != 1) {
        succ_cb && succ_cb();
      } else {
        const html = `<div class="ept-second-comfirm-wapper">
          <p class="ept-second-comfirm-title"><img class="ept-second-comfirm-img" src="${require('@/assets/image/warning.png')}" alt="">注意</p>
          <div class="ept-second-comfirm-body">有文件正在上传，确定要中断吗？</div>
        </div>`;
        this.$confirm(html, '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          showClose: false,
          customClass: 'ept-second-comfirm-dialog'
        })
          .then(() => {
            this.clearAll();
            succ_cb && succ_cb();
          });
      }
    },
    init() {
      if (this.dialogVisible) {
        document.body.style.overflow = 'hidden';
      }
    },

    clickVisible() {
      // 判断一下，当前如果是缩小模式，则需要放大处理
      this.$nextTick(() => {
        if (this.isSmall) {
          this.isSmall = false;
        }
      });
    },

    hideDialog() {
      this.$confirm('是否关闭补填信息导入弹窗', '注意')
        .then(res => {
          this.close();
        });
    },
    close() {
      this.clearAll();
      this.$emit('clickClose');
      this.dialogVisible = false;
      document.body.style.overflow = 'auto';
    },
    clearAll() {
      this.$store.dispatch('ConfirmationTaskDel');
      this.matchProgress = 0;
      this.titleWidth = '635px';
      this.showLoading = false;
      this.$refs.confirmationUploadViewRef.clearFile();
    },

    clickEnlarge() {
      this.isSmall = false;
      document.body.style.overflow = 'hidden';
    },

    clickCancel() {
      this.hideDialog();
    },

    clickSmall() {
      this.isSmall = true;
      document.body.style.overflow = 'auto';
    },
    clickRetry() {
      this.clearAll();
    },
    uploadFail() {
      this.$message.error('没有找到符合要求的文件');
      this.clickRetry();
    },
    uploadProgress(progress) {
      this.matchProgress = Number(progress) / 2;
    },
  },

};
</script>

<style lang="scss" rel="stylesheet/scss">
//和文书批量上传公用一套css
.confirmation-batch-upload-dialog {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.64);
}

.batch-upload-dialog-main {
  display: flex;
  flex-direction: column;
  background: #f8f8f8;
}

.batch-upload-dialog-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 24px;
  padding-left: 40px;
  height: 56px;
  border-bottom: 1px solid #e8e8e8;
}

.batch-upload-dialog-content {
}


/**
缩小后样式
 */

.confirmation-batch-upload-dialog-small {
  position: fixed;
  top: calc(50vh - 34px);
  right: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
}

.batch-upload-dialog-small-main {
  width: 68px;
  height: 68px;
}

</style>
